import determineLatePayText from "./determine_late_pay_text";

export const creditReportCreditCard = (creditInfo, creditHistoryMonths, nbrMonths) => {
    let status = "";
    if (creditInfo.currentlyActive === true){
        status = "active";
    }else{
        status = "inactive";
    }
    let nbrPayments = +creditHistoryMonths - +nbrMonths;
    let mostRecentLatePayText = "";
    let oldestLatePayText = "";
    let latePayCount = 0;
    if (creditInfo.paymentHistory){
        nbrPayments = creditInfo.paymentHistory.length - +nbrMonths;
        const paymentHistory = creditInfo.paymentHistory;
        //  ignore 'current' months.  In this case, a current month is the last turn
        //  if a credit card bills at end of last month, then player has 1 turn to make
        //  a payment before it impacts their credit score.
        const offset = +nbrMonths;
        const maxIndx = paymentHistory.length - offset - 1;
        let oldestLatePay = 0;
        let mostRecentLatePay = 0;
        let payNbr = 0;
        for (let i=maxIndx; i>0; i--){
            payNbr = payNbr + 1;
            if (paymentHistory[i].payStatus === "unpaid" ||
                paymentHistory[i].payStatus === "paidLate"
            ){
                latePayCount += 1;
                oldestLatePay = payNbr - 1;
                if (mostRecentLatePay === 0){
                    mostRecentLatePay = payNbr;
                }
            }
        }   
        if (latePayCount > 0){
            const latePayText = determineLatePayText(latePayCount, oldestLatePay, mostRecentLatePay);
            oldestLatePayText = latePayText.oldestLatePayText;
            mostRecentLatePayText = latePayText.mostRecentLatePayText;
        }       
       
    }
    const returnObj = {status:  status, nbrPayments: nbrPayments, latePayCount: latePayCount,
        mostRecentLatePayText: mostRecentLatePayText, oldestLatePayText: oldestLatePayText }
    return returnObj;
}
export default creditReportCreditCard;